import React from "react";
import cappucino from '../../../images/kapuco.svg'
import './Contacts.scss'
import { Img } from "@randajan/jet-react/dom/img";
import { Link, LinkTel } from "@randajan/jet-react/dom/link";


const Contacts = () => {
    return (
        <section className="Contacts slab">
            <section className='contactsInfo'>
                <h2>
                    <Img src={cappucino}/>
                    <span>
                        <strong>Kontakt</strong>
                        <small>Zastavte se u nás na kus palačinky</small>
                    </span>
                </h2>
                <article className='info'>
                    <p className='smallText'>
                        <span>CAFÉ & PALAČINKA</span>
                        <br/>
                        <Link to="https://maps.app.goo.gl/QhRrevp6W8hnPAFb6">Moskevská 268/53, Praha 10, 101 00</Link>
                    </p>
                    <p className='workingHours'>PO - PÁ  9:00 - 19:00 <br />SO - NE  9:00 - 18:00</p>
                    <p className='smallText'>Telefon: <LinkTel>+420 605 861 877</LinkTel></p>
                    <p className='smallText'>Provozovatel:<br/>Jan Kristián Rokos<br/>Moskevská 268/53, Praha 10, 101 00<br/>IČO: 05035007</p>
                </article>
            </section>
            <section className='map'>
                <iframe
                    title="Google Map"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2560.9321415578024!2d14.454783877041388!3d50.068832471521866!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b930072a9dab1%3A0xc9f85acd6fc6cee4!2zQ2Fmw6kgYSBQYWxhxI1pbmth!5e0!3m2!1scs!2scz!4v1740053511834!5m2!1scs!2scz"
                ></iframe>
            </section>
        </section>
    );
};

export default Contacts;
